import moment from 'moment'

export const serializeFormValue = (value: unknown): string => {
  if (moment.isMoment(value)) {
    return value.toISOString()
  } else if (typeof value === 'string') {
    return value.trim()
  } else {
    return value?.toString() || ''
  }
}
